"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SplashScreen = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _Splash_Desktop = _interopRequireDefault(require("./Splash_Desktop.gif"));

var _Splash_Mobile = _interopRequireDefault(require("./Splash_Mobile.gif"));

require("./SplashScreen.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var desktopWidth = '1024px';
var fadeExitDuration = 500;

var Transition = /*#__PURE__*/_react["default"].forwardRef(function Transition(props, ref) {
  // eslint-disable-line
  return /*#__PURE__*/_react["default"].createElement(_material.Fade, _extends({
    ref: ref
  }, props, {
    timeout: {
      enter: 0,
      exit: fadeExitDuration
    }
  }));
});

var SplashScreen = /*#__PURE__*/function (_React$Component) {
  _inherits(SplashScreen, _React$Component);

  var _super = _createSuper(SplashScreen);

  function SplashScreen() {
    var _this;

    _classCallCheck(this, SplashScreen);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isSmallScreen: window.innerWidth <= parseInt(desktopWidth),
      displaySplash: true
    });

    return _this;
  }

  _createClass(SplashScreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          isAppLoading = _this$props.isAppLoading,
          splashHasDisplayed = _this$props.splashHasDisplayed,
          toggleSplashHasDisplayed = _this$props.toggleSplashHasDisplayed;

      if (isAppLoading || !splashHasDisplayed) {
        // sets minimum time for splash animation to run, even if account list is loaded earlier
        setTimeout(function () {
          return _this2.setState({
            displaySplash: false
          });
        }, 3000);
      } else {
        // prevents splash screen running after initial login
        this.setState({
          displaySplash: false
        });
        toggleSplashHasDisplayed();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props2 = this.props,
          isAppLoading = _this$props2.isAppLoading,
          toggleSplashHasDisplayed = _this$props2.toggleSplashHasDisplayed;
      var displaySplash = this.state.displaySplash;

      if (!isAppLoading && !displaySplash && prevState.displaySplash // triggers if app has loaded before min display time
      || !isAppLoading && prevProps.isAppLoading && !displaySplash) {
        // triggers if app finished loading after min display time
        setTimeout(function () {
          return toggleSplashHasDisplayed();
        }, fadeExitDuration); // delays splashHasDisplayed toggle by extra Fade exit time
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          displaySplash = _this$state.displaySplash,
          isSmallScreen = _this$state.isSmallScreen;
      var isAppLoading = this.props.isAppLoading;
      return /*#__PURE__*/_react["default"].createElement(_material.Dialog, {
        fullScreen: true,
        open: isAppLoading || displaySplash,
        onClose: null,
        TransitionComponent: Transition
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "SplashScreen_splashScreenContainer"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "SplashScreen_splashScreen"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: isSmallScreen ? _Splash_Mobile["default"] : _Splash_Desktop["default"],
        alt: "spashLogo",
        className: "SplashScreen_splashScreenLogo"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "SplashScreen_pulsingOne"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "SplashScreen_pulsingTwo"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "SplashScreen_pulsingThree"
      }))));
    }
  }]);

  return SplashScreen;
}(_react["default"].Component);

exports.SplashScreen = SplashScreen;

_defineProperty(SplashScreen, "propTypes", {
  isAppLoading: _propTypes["default"].bool.isRequired,
  toggleSplashHasDisplayed: _propTypes["default"].func.isRequired,
  splashHasDisplayed: _propTypes["default"].bool.isRequired
});

var _default = SplashScreen;
exports["default"] = _default;